import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';

import { useTranslation } from '../../../translations';
import ProfileAllSelector from '../Selects/ProfileAllSelector';

interface SelectOption {
  value: string | undefined;
  label: string;
}

interface StageModalFiltersProps {
  monthsOptions: SelectOption[];
  projectId: string;
  selectedMonth: string | undefined;
  selectedProfile: string | undefined;
  onMonthChange: (month: string | undefined) => void;
  onProfileChange: (profile: string | undefined) => void;
}

export const StageModalFilters: React.FC<StageModalFiltersProps> = ({
  monthsOptions,
  projectId,
  selectedMonth,
  selectedProfile,
  onMonthChange,
  onProfileChange,
}) => {
  const { t, tk } = useTranslation('projectLng');

  return (
    <Card className="stage-modal-card stage-modal-card-filters rounded-3">
      <div className="d-flex align-items-center gap-3 mb-3">
        <label className="form-label mb-0 text-nowrap stage-modal-label">
          {t(tk.timeLine.month)}
        </label>
        <div className="flex-grow-1 stage-modal-select">
          <Select
            value={monthsOptions.find(({ value }) => value === selectedMonth)}
            options={monthsOptions}
            onChange={option => onMonthChange(option?.value)}
          />
        </div>
      </div>
      <div className="d-flex align-items-center gap-3">
        <label className="form-label mb-0 text-nowrap stage-modal-label">
          {t(tk.timeLine.profile)}
        </label>
        <div className="flex-grow-1 stage-modal-select">
          <ProfileAllSelector
            projectId={projectId}
            value={selectedProfile}
            onChange={option => onProfileChange(option?.value)}
            showAllOption={true}
          />
        </div>
      </div>
    </Card>
  );
};
